import { createAsyncThunk } from '@reduxjs/toolkit';
import cogsApi from '~/apis/cogs';
import { CREATE_COGS, GET_COGS, EDIT_COGS, GET_COGS_LIST } from '~/utils/constants/actionType';
import { ICogs, IParamsGetCogs, IResponseGetCogs } from '~/utils/interface/cogs';

export const handleCreateCogs = createAsyncThunk<ICogs, ICogs>(
  CREATE_COGS,
  async (data: ICogs, { rejectWithValue }) => {
    try {
      const res = await cogsApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCogsList = createAsyncThunk<IResponseGetCogs, IParamsGetCogs>(
  GET_COGS_LIST,
  async (params: IParamsGetCogs = {}, { rejectWithValue }) => {
    try {
      const res = await cogsApi.getList(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCogs = createAsyncThunk<ICogs, string>(GET_COGS, async (id: string, { rejectWithValue }) => {
  try {
    const res = await cogsApi.getDetail(id);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleEditCogs = createAsyncThunk<ICogs, { id: string | undefined; params: ICogs }>(
  EDIT_COGS,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await cogsApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
